// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__EjVDH","disclaimer":"styles_disclaimer__kseu1"};